import { BlockComponentModel } from '@/components/cms/types/blok-component';

import { TopBanner } from '.';
import { TopBannerProps } from './types';

export const TopBannerStrapi = ({
  block,
}: BlockComponentModel<TopBannerProps>) => {
  const { bannerContent } = block;

  return <TopBanner bannerContent={bannerContent} />;
};
